module.exports = __webpack_public_path__ + "static/media/inviteSuccess.ff863115.png";